import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import i18next from 'i18next';
// Only one feature at a time as its not cheap to branch so many keys and we
// want to keep it sane, so one mass babel migrtion at a time!
const ACTIVE_FLAG = 'adoptables_resale';
const featureBrancher = {
    name: 'featureBrancher',
    type: 'postProcessor',
    process: function process(value, key, options, translator) {
        const firstKey = key[0];
        if (translator.options.i18nFeatureBranch && !firstKey.startsWith(translator.options.i18nFeatureBranch)) {
            let branchedKey = `${translator.options.i18nFeatureBranch}.${firstKey}`;
            // Handle NS keys
            if (firstKey.includes(':')) {
                const parts = firstKey.split(':');
                branchedKey = `${parts[0]}:${translator.options.i18nFeatureBranch}.${parts[1]}`;
            }
            if (i18next.exists(branchedKey)) {
                const newOpts = _object_spread({}, options);
                if (Array.isArray(newOpts.postProcess) && newOpts.postProcess.includes('reactPostprocessor')) {
                    newOpts.postProcess = [
                        'reactPostprocessor'
                    ];
                }
                return i18next.t(branchedKey, newOpts);
            }
        }
        return value;
    },
    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
        return {
            postProcess: 'featureBrancher'
        };
    }
};
const setupI18nextFeatureBranching = (flags, i18n)=>{
    if (ACTIVE_FLAG && flags && flags.includes(ACTIVE_FLAG)) {
        i18n.options.i18nFeatureBranch = ACTIVE_FLAG;
    }
};
export default featureBrancher;
export { setupI18nextFeatureBranching };
